/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Type_ArchivedInputs */

const en_sch_err_type_archived = /** @type {(inputs: Sch_Err_Type_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That type is archived. Choose an active type.`)
};

const de_sch_err_type_archived = /** @type {(inputs: Sch_Err_Type_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Typ ist archiviert. Wähle einen aktiven Typ.`)
};

/**
* | output |
* | --- |
* | "That type is archived. Choose an active type." |
*
* @param {Sch_Err_Type_ArchivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_type_archived = /** @type {((inputs?: Sch_Err_Type_ArchivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Type_ArchivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_type_archived(inputs)
	return en_sch_err_type_archived(inputs)
});